import { createFileRoute } from "@tanstack/react-router";

import { LedgerLink } from "@/components/site/ctas";
import { Markets } from "@/components/site/home-sections";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/markets/")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.nav.markets} · insidermark` }, { name: "description", content: t.marketsSection.body }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const regions = Array.from(new Set(t.markets.map((m) => m.region)));
  return (
    <main>
      <div className="pt-12">
        <Markets lang={lang} t={t} asPage />
      </div>
      <section className="im-section im-section--tight">
        <div className="im-wrap grid gap-12 md:grid-cols-3">
          {regions.map((r) => (
            <Reveal key={r}>
              <h2 className="im-h3 mb-4">{r}</h2>
              {t.markets
                .filter((m) => m.region === r)
                .map((m, i) => (
                  <LedgerLink
                    key={m.slug}
                    to={href(lang, `/markets/${m.slug}`)}
                    index={`0${i + 1}`}
                    title={m.name}
                    sub={m.phase === 2 ? t.marketPage.phase2 : m.logistics.destination}
                  />
                ))}
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
